<template>
  <pict
    class="high-five-image__image"
    block-name="high-five-image"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import image from "./images/high-five.png"
import image2x from "./images/high-five@2x.png"

export default {
  name: "HighFiveImage",
  components: {
    Pict
  },
  computed: {
    imageProps() {
      return {
        default: {
          src: image,
          srcset: {
            "2x": image2x
          }
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "Well done badge"
      },
      de: {
        alt: "Gut gemacht badge"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.high-five-image__image {
  max-width: 248px;
}

.high-five-image {
  ::v-deep &__image {
    width: 100%;
  }
}
</style>
